import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Apartment } from 'projects/apex/src/app/models/apartment';

@Component({
  selector: 'apex-client-addon-package-order-return-page',
  templateUrl: './addon-package-order-return.component.html',
  styleUrls: ['./addon-package-order-return.component.scss'],
})
export class ClientAddonPackageOrderReturnPageComponent implements OnInit {
  apartment: Apartment;
  success: boolean;
  message: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
  ) {}

  ngOnInit(): void {
    const data = this.route.snapshot.data;

    this.apartment = data.apartment;

    // Check query params for success/error status
    const queryParams = this.route.snapshot.queryParams;

    this.success = queryParams['success'] === 'true';
  }
}
